import React from 'react';
import { observer } from 'mobx-react';
import Avatar from '../../../../components/Avatar';
import cx from 'classnames';
import styles from './CallPrompt.m.sass';
import { CallStatusInfo } from './CallPromptInfo';
import { useCallingConversationViewModel, useCallRootViewModel } from '../../CallingConversationViewModel/index';
import ProgressSpinner from '../../../../components/ProgressSpinner';
import { extractMessageFromError } from '../../../../utils/errorUtil';
import { CallParticipantStatus } from '../../CallParticipant';
import { CallPromptActions } from './CallPromptActions';
export var CallPrompt = observer(function CallPrompt(_ref) {
  var call = _ref.call,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered;
  var vm = useCallingConversationViewModel().callPromptViewModelFor(call);
  var callRootViewModel = useCallRootViewModel();

  // callViewModel is provided depending on whether the portal
  // sets up a callRootViewModel or not
  var callViewModel = callRootViewModel ? callRootViewModel.callViewModelFor(call) : null;
  var operatorState = callViewModel ? callViewModel.state : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, bordered && styles.bordered)
  }, vm.fetch.match({
    pending: function pending() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProgressSpinner, null));
    },
    rejected: function rejected(err) {
      return /*#__PURE__*/React.createElement("div", null, extractMessageFromError(err));
    },
    resolved: function resolved() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles.main
      }, /*#__PURE__*/React.createElement(CallStatusInfo, {
        vm: vm,
        operatorState: operatorState
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.menu
      }, /*#__PURE__*/React.createElement(CallParticipants, {
        participants: vm.participants
      }), callViewModel && /*#__PURE__*/React.createElement(CallPromptActions, {
        callViewModel: callViewModel
      })));
    }
  }));
});
export var CallParticipants = observer(function CallParticipants(_ref2) {
  var participants = _ref2.participants;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.participants
  }, participants.length > 4 ? /*#__PURE__*/React.createElement("span", {
    className: styles.participantCount
  }, participants.length, " participants") : participants.map(function (p) {
    return /*#__PURE__*/React.createElement("div", {
      title: p.member ? p.member.displayName : '',
      key: p.userId,
      className: cx(styles.participant, p.status !== CallParticipantStatus.Connected && styles.disconnected)
    }, /*#__PURE__*/React.createElement(Avatar, {
      size: 30,
      url: p.member ? p.member.avatar : null
    }));
  }));
});
//# sourceMappingURL=index..js.map
